











import { Component, Vue, Prop } from "@/common";

@Component({})
export default class TwExport extends Vue {
  @Prop({})
  action!: string;

  @Prop({ default: "primary" })
  type!: string;

  @Prop({ default: () => {} })
  data!: object;

  @Prop({})
  text!: string;

  @Prop({})
  icon!: string;

  private loading: boolean = false;

  private download() {
    this.loading = true;
    this.$http
      .post(this.action,this.data, { responseType: "blob"})
      .then(res => {
        this.loading = false;
        const filename = decodeURIComponent(res.headers["filename"]);
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(res.data, filename);
        } else {
          let url = window.URL.createObjectURL(res.data);
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          URL.revokeObjectURL(link.href);
        }
      })
      .catch(err => {
        this.loading = false;
      });
  }
}
